(function oc_41_pdp_v1() {
    let isMobile = window.matchMedia('(max-width:1023px)').matches;
    if (isMobile) {
        if (typeof productOriginal !== typeof undefined && typeof tns !== typeof undefined && (document.querySelector('.details-care-section') || document.querySelector('#people-also')) && !document.querySelectorAll('.oc_41_pdp_v1').length) {
            getReviews(function (revArr) {
                addReviews(revArr)
            });
            document.body.classList.add('oc_41_pdp_v1');
        } else if (!document.querySelectorAll('.oc_41_pdp_v1').length) {
            requestAnimationFrame(oc_41_pdp_v1);
        }
        function getReviews(cb) {
            let storeId = `13158c42-3a7d-47a7-87e2-e56a625390de`;
            let prodId = productOriginal.id;
            let orderBy = `date desc`;
            let limit = 500;
            const xhttp = new XMLHttpRequest();
            xhttp.onload = function () {
                if (this.responseText) {
                    let reviewsParsed = JSON.parse(this.responseText);
                    cb(reviewsParsed.reviews);
                }
            }
            xhttp.open("GET", `https://api.okendo.io/v1/stores/${storeId}/products/shopify-${prodId}/reviews?limit=${limit}&orderBy=${orderBy}`);
            xhttp.send();
        }
        function addReviews(reviews) {
            let detailsSec = document.querySelector('.details-care-section') || document.querySelector('#people-also');
            if (detailsSec && reviews.length >= 3 && !document.querySelector('.oc_reviewsSliderArea')) {
                let sHtm = `
                <div class="oc_reviewsSliderArea okeReviews okeReviews--theme js-okeReviews">
                    <div class="oc_reviewsSliderTNS">
                        ${(function () {
                        let cHtm = ``;
                        reviews.forEach(function (review, i) {
                            let rating = review.rating;
                            let average = ((rating / 5) * 100).toFixed(2);
                            let isVerified = review.reviewer.isVerified;
                            let badgeHtm = ``;
                            if (isVerified) {
                                badgeHtm = `<div class="okeReviews-review-reviewer-profile-status okeReviews-review-reviewer-profile-status--verified">Verified Buyer</div>`;
                            }
                            if (i <= 4) {
                                cHtm += `
                                    <div class="oc_reviewCard">
                                        <h3 class="oc_revTitle">${review.title}</h3>
                                        <div class="okeReviews-review-starRating">
                                            <div class="okeReviews-starRating">
                                                <span class="okeReviews-starRating-indicator" role="presentation">
                                                    <span class="okeReviews-starRating-indicator-layer"></span>
                                                    <span class="okeReviews-starRating-indicator-layer okeReviews-starRating-indicator-layer--foreground" style="width: ${average}%;"></span>
                                                </span>
                                            </div>
                                        </div>
                                        <div class="oc_reviewsText"><q>${review.body}</q></div>
                                        <div class="oc_authorPagination">
                                            <div class="oc_authorCol">
                                                <h4>${review.reviewer.displayName}</h4>
                                                ${badgeHtm}
                                            </div>
                                        </div>
                                    </div>`;
                            }
                        });
                        return cHtm;
                    })()}
                    </div>
                    <div class="oc_pagination">
                        <div class="oc_pages"><span class="oc_currentSlide">1</span>/<span class="oc_maxSlides">${reviews.length >= 5 ? 5 : reviews.length}</span></div>
                        <div class="oc_revarrows">
                            <span class="oc_prev">
                            <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect width="40" height="40" fill="#F6F6F6"/>
<mask id="mask0_3333_525" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="11" y="11" width="18" height="18">
<rect x="11" y="11" width="18" height="18" fill="#D9D9D9"/>
</mask>
<g mask="url(#mask0_3333_525)">
<path d="M21.4981 24.2403L17.2578 20L21.4981 15.7596L22.2884 16.55L18.8384 20L22.2884 23.45L21.4981 24.2403Z" fill="#1C1B1F"/>
</g>
</svg>
</span>
                            <span class="oc_next">
                            <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect width="40" height="40" transform="translate(40 40) rotate(-180)" fill="#F6F6F6"/>
<mask id="mask0_3333_529" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="11" y="11" width="18" height="18">
<rect x="29" y="29" width="18" height="18" transform="rotate(-180 29 29)" fill="#D9D9D9"/>
</mask>
<g mask="url(#mask0_3333_529)">
<path d="M18.5019 15.7597L22.7422 20L18.5019 24.2404L17.7116 23.45L21.1616 20L17.7116 16.55L18.5019 15.7597Z" fill="#1C1B1F"/>
</g>
</svg>

                            </span>
                        </div>
                    </div>
                </div>`;
                detailsSec.insertAdjacentHTML('beforebegin', sHtm);
                checkIfSlidesAndRemove();
                updateMaxSlides();
                initializeReviews();
            }
        }

        function checkIfSlidesAndRemove() {
            let allSlides = document.querySelectorAll('.oc_reviewCard');
            let slideParent = document.querySelector('.oc_reviewsSliderArea');
            if (allSlides.length == 0) {
                slideParent.remove();
            }
        }

        function updateMaxSlides() {
            let maxSlidesEl = document.querySelector('.oc_maxSlides');
            let allSlides = document.querySelectorAll('.oc_reviewCard');
            if (maxSlidesEl) {
                maxSlidesEl.innerText = allSlides.length;
            }
        }

        function initializeReviews() {
            if (document.querySelector('.oc_reviewsSliderTNS')) {
                var slider = tns({
                    container: '.oc_reviewsSliderTNS',
                    items: 1,
                    slideBy: 'page',
                    autoplay: false,
                    controls: true,
                    nav: false,
                    controlsContainer: '.oc_revarrows',
                    loop: false,
                    autoHeight: true
                });

                slider.events.on('transitionEnd', function (info) {
                    let currIndex = ++info.index;
                    let currSlideEl = document.querySelector('.oc_currentSlide');
                    if (currSlideEl) {
                        currSlideEl.innerText = currIndex;
                    }
                });
            }
        }
    }
})();